import {Component, Prop, Vue, Emit} from 'vue-property-decorator';
import Service from '../../../../common/src/assets/service/service';
import Common from '../../../../common/src/assets/js/common';
import environment from '../../../../common/src/assets/environment/environment';
@Component
export default class Authentication extends Vue {
    private $platform: any;
    private $router: any;
    private userID: string = '';
    private userInfo: any = {};         // 用户基础信息

    private status: any = {
        loading: '',
        code: 'loading',
        type: 'person'
    }
    private imgPrefix: string = '';
    private qrcodeSrc: string = '';


    private created() {
        this.userID = Common.getUserID(this.$platform);
        this.imgPrefix = environment.apiPrefix;
        this.getUserInfo();
    }
        /**获取用户信息 */
    private getUserInfo() {
        let params = {
            userID: this.userID,
        };
        this.status.code = 'loading';
        Service.request('/user/queryCustomerInfo', params, 'token')
            .then((res: any) => {
                let data = res.data;
                this.userInfo = data;
                // 如果已个人实名了，说明是升级企业实名
                if (this.userInfo.personVeriyed === 1) {
                    this.status.type = 'company';
                } else {
                    this.status.type = 'person';
                }

                this.getQrcode();

            })
            .catch(error => {
                this.getQrcode();
            });
    }

    /**获取二维码 */
    private getQrcode() {
        let params = {
            userID: this.userID,
            outreachOperate: this.status.type,
        };
        Service.request('/user/getLiveCode', params, 'token')
        .then((res: any) => {
            this.status.code = 'havedata'
            this.qrcodeSrc = res.data;
        })
        .catch(error => {
            this.status.code = 'nodata'
        });
    }

    private back() {
        this.$router.back();
    }

    private skipHelpDoc() {
        window.open('/manage/doc/授权委托书.docx')
    }
}